import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Section Logo & About */}
        <div className="footer-section about">
          <img
            src="/image/image90.jpg"
            alt="CFJEXPERT Logo"
            className="footer-logo"
          />
          <p>
            CFJEXPERT est votre partenaire de confiance pour créer et gérer votre entreprise au Maroc.
            Nous offrons expertise, conseils et solutions sur mesure pour assurer le succès de vos projets.
          </p>
        </div>

        {/* Section Links */}
        <div className="footer-section links">
          <h4>Liens Utiles</h4>
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/services">Nos Services</Link></li>
            <li><Link to="/about">À Propos</Link></li>
            <li><Link to="/testimonials">Témoignages</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Section Contact */}
        <div className="footer-section contact">
          <h4>Contactez-Nous</h4>
          <p>Email: info@cfjexpert.com</p>
          <p>Téléphone: +212 6 12 34 56 78</p>
          <p>Adresse: Casablanca, Maroc</p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} CFJEXPERT. Tous droits réservés.</p>

        <p className="created-by">
          Site web réalisé par{" "}
          <a
            href="https://ite.ma/"
            target="_blank"
            rel="noopener noreferrer"
          >
            ITE Consulting
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
